import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";
import { TCountryCode } from "countries-list";
import {
  otherArray,
  otherFeeArray,
  otherEvidenceFileIdArray,
} from "@/utils/arrayState";

type OtherIndex = (typeof otherArray)[number];
type OtherFeeIndex = (typeof otherFeeArray)[number];
type OtherEvidenceFileIdIndex = (typeof otherEvidenceFileIdArray)[number];

export type InvoiceShipOperator = {
  [other in OtherIndex]: string | null; // other{1-10}
} & {
  [otherFee in OtherFeeIndex]: number | null; // otherFee{1-10}
} & {
  [otherEvidenceFileId in OtherEvidenceFileIdIndex]: string | null; // otherEvidence{1-10}Id
} & {
  id: string;
  poNumber: string | null;
  invoiceID: string | null;
  sequenceID: string | null;
  invoiceDate: string;
  shipOwnerId: string;
  vesselId: string;
  invoiceCompanyId: string | null;
  companyName: string;
  address : string | null;
  shipName: string;
  inspectionDate: string;
  country: TCountryCode;
  port: string;
  isIndonesia: boolean;
  isPPN: boolean;
  isSignature: boolean;
  jobDescription: string;
  inspectionFee: number;
  awaitingDays: number;
  awaitingDaysFee: number;
  subTotal: number;
  ppn: number;
  amount: number;
  note: string | null;
  paymentStatus: number;
  invoiceStatus: number;
  downloadId: string | null;
  paymentDownloadId: string | null;
  paymentDate: string | null;
  type: string;
  sireType: string;
  feeId: string;
  kurs: number;
  kursDate: string;
  isKursConversion: boolean;
  mataUang: string | null;
  kursConversion: number | null;
  convertionNotes: string | null;
  convertionUploadId: string | null;
  conversionAmount: number | null;
  fakturId: string | null;
  totalAmountIDR: number | null;
  sktdId: string | null;
  created: string;
};

const getListInvoicesShipOwner = async (param: any) => {
    const query = `?search=${param.search}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus ?? ''}&type=${param.type}&market=${param.market}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/Invoices/GetAllInvoices${query}`;
    return apiCall('get', URL);
};

const getListInvoicesByFinance = async (param: any) => {
    const query = `?search=${param.search}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus ?? ''}&type=${param.type}&market=${param.market}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/Invoices/GetAllInvoicesFinance${query}`;
    return apiCall('get', URL);
};

const getListInvoicesByShipOwner = async (param: any) => {
    const query = `?id=${param.id}&paymentStatus=${param.paymentStatus}&invoiceStatus=${param.invoiceStatus}&type=${param.type}&search=${param.search}&market=${param.market}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/Invoices/GetAllInvoicesByShipOwner${query}`;
    return apiCall('get', URL);
};

const getInvoicesShipOwnerById = async (id: string) => {
  const URL = `/Invoices/GetInvoiceById/${id}`;
  return apiCall("get", URL);
};

const putInvoicesShipOwner = async (data: any) => {
  const URL = "/Invoices/Update";
  // return apiCall('post', URL, data);
  try {
    const response = await axiosInstance.post<any>(URL, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    };
    return obj;
  }
};

const postInvoicesShipOwner = async (data: any) => {
  const URL = "/Invoices/Create";
  return apiCall("post", URL, data);
};

const deleteInvoicesShipOwner = async (data: any) => {
  const URL = "/Invoices/Delete";
  return apiCall("post", URL, data);
};

const updateInvoiceStatusShipOwner = async (data: any) => {
  const URL = "/Invoices/UpdateInvoiceStatus";
  return apiCall("post", URL, data);
};

const updatePaymentStatusShipOwner = async (obj: any) => {
  const URL = "/Invoices/UpdatePaymentStatus";

  try {
    const response = await axiosInstance.post<any[]>(URL, obj, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err: any) {
    const obj = {
      status: err?.response?.status,
      message: err?.response?.data?.message,
    };
    return obj;
  }
};

export {
  deleteInvoicesShipOwner,
  postInvoicesShipOwner,
  putInvoicesShipOwner,
  getInvoicesShipOwnerById,
  getListInvoicesShipOwner,
  updateInvoiceStatusShipOwner,
  updatePaymentStatusShipOwner,
  getListInvoicesByShipOwner,
  getListInvoicesByFinance,
};
